import { render, staticRenderFns } from "./GroupBookingStatusSummary.vue?vue&type=template&id=04f7f086&scoped=true&"
import script from "./GroupBookingStatusSummary.vue?vue&type=script&lang=js&"
export * from "./GroupBookingStatusSummary.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingStatusSummary.vue?vue&type=style&index=0&id=04f7f086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f7f086",
  null
  
)

export default component.exports